import axios, { isAxiosError } from "axios";
import { Cookies } from "react-cookie";

import { auth } from "#/utils";
import { env } from "@monta/env";

export const monolithicClient = axios.create({
  baseURL: `${env.API_URL}/monolithic`
});

monolithicClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  return config;
});

monolithicClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  // const cookies = new Cookies();
  // const refresh = cookies.get("refreshToken");

  // if (!refresh) window.location.reload();

  if (error.response?.status === 401) {
    // window.location.href = "/auth";
    auth.logout();
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    // window.location.href = "/auth";
    console.log("403");
  }
});

export const gwtClient = axios.create({
  baseURL: `${env.API_URL}/`
});

gwtClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  // parameter to set for changing content type to default
  if (!config.fetchOptions?.["isJson"])
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded; charset=UTF-8";
  return config;
});

gwtClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  if (error.response?.status === 401) {
    // window.location.href = "/auth";
    auth.logout();
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    // window.location.href = "/auth";
    console.log("403");
  }
});

export const nodeClient = axios.create({
  baseURL: `${env.LEGACY_APPLICATION_URL}/api`
});

nodeClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  config.headers.Accept = "application/pdf";
  return config;
});

nodeClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  if (error.response?.status === 401) {
    // window.location.href = "/auth";
    auth.logout();
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    // window.location.href = "/auth";
    console.log("403");
  }
});
